<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-08-24 16:05:54
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-14 09:54:59
-->
<script>
export default {
	render(h) {
		const childrens = this.$slots.default?.map(item => item.tag && h('div', { class: 'pt-12 pb-12' }, [item])) || [];
		return h('div', { class: 'radius-8 yx-background-white flex-column pl-24 pr-24' }, [
			this.$slots['header'] ? h('div', { class: 'pt-16 pb-16   yx-border-bottom' }, [this.$slots['header'][0]]) : null,
			h('div', { style: { 'min-height': '100px' }, class: 'flex flex-just-between flex-1' }, childrens),
			this.$slots['footer'] ? h('div', { class: 'pt-12 pb-12 yx-border-top' }, [this.$slots['footer'][0]]) : null,
		]);
	},
};
</script>